import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function CustomCursor() {
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);
  const [isVisible, setIsVisible] = useState(true);
  
  // Spring configuration for smooth following
  const springConfig = { damping: 25, stiffness: 350, mass: 0.5 };
  const cursorXSpring = useSpring(cursorX, springConfig);
  const cursorYSpring = useSpring(cursorY, springConfig);
  
  // Trail effect with slower spring
  const trailSpringConfig = { damping: 20, stiffness: 150, mass: 0.8 };
  const trailX = useSpring(cursorX, trailSpringConfig);
  const trailY = useSpring(cursorY, trailSpringConfig);

  // Constant sizes - never change
  const TRAIL_SIZE = 25;      // Constant trail size
  const OUTER_SIZE = 25;      // Constant outer circle size
  const INNER_SIZE = 4;       // Constant inner dot size

  useEffect(() => {
    const moveCursor = (e) => {
      cursorX.set(e.clientX);
      cursorY.set(e.clientY);
      if (!isVisible) setIsVisible(true);
    };

    const handleMouseLeave = () => {
      setIsVisible(false);
    };

    const handleMouseEnter = () => {
      setIsVisible(true);
    };

    // Add event listeners
    window.addEventListener('mousemove', moveCursor);
    window.addEventListener('mouseleave', handleMouseLeave);
    window.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      window.removeEventListener('mouseleave', handleMouseLeave);
      window.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [cursorX, cursorY, isVisible]);

  return (
    <>
      {/* Trail Effect - Constant size */}
      <motion.div
        className="custom-cursor-trail"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          x: trailX,
          y: trailY,
          width: TRAIL_SIZE,
          height: TRAIL_SIZE,
          backgroundColor: 'rgba(1, 155, 215, 0.08)',
          border: '1px solid rgba(1, 155, 215, 0.3)',
          borderRadius: '50%',
          translateX: '-50%',
          translateY: '-50%',
          opacity: isVisible ? 0.6 : 0,
          zIndex: 999999,
          pointerEvents: 'none',
        }}
        transition={{ duration: 0.1 }}
      />

      {/* Outer Circle - Constant size, no hover/click change */}
      <motion.div
        className="custom-cursor-outer"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          x: cursorXSpring,
          y: cursorYSpring,
          width: OUTER_SIZE,
          height: OUTER_SIZE,
          backgroundColor: 'rgba(1, 155, 215, 0.1)',
          border: '2px solid #019BD7',
          borderRadius: '50%',
          translateX: '-50%',
          translateY: '-50%',
          opacity: isVisible ? 1 : 0,
          zIndex: 999999,
          pointerEvents: 'none',
        }}
        transition={{ duration: 0.05 }}
      />

      {/* Inner Dot - Constant size, no hover/click change */}
      <motion.div
        className="custom-cursor-inner"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          x: cursorX,
          y: cursorY,
          width: INNER_SIZE,
          height: INNER_SIZE,
          backgroundColor: '#019BD7',
          borderRadius: '50%',
          translateX: '-50%',
          translateY: '-50%',
          opacity: isVisible ? 1 : 0,
          zIndex: 999999,
          pointerEvents: 'none',
        }}
        transition={{ duration: 0 }}
      />
    </>
  );
}